import { createFileRoute, redirect } from "@tanstack/react-router";

// Backwards-compat: sign-up entry moved into the onboarding flow.
// Preserve any query params (UTM, ref, ...) so attribution survives.
export const Route = createFileRoute("/(auth-pages)/aanmelden")({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/onboarding/$step",
      params: { step: "provider-selection" },
      search,
    });
  },
});
